import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';

export function Location() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">LOCALIZACIÓN Y CONTACTO</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="relative w-full h-64">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24626.351906741365!2d-0.444299!3d39.507854!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd6045a456535235%3A0xc2a24e67f00ed8e!2sSandra%20Est%C3%A9tica%20y%20Quiromasaje!5e0!3m2!1ses!2ses!4v1741126441053!5m2!1ses!2ses"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="absolute inset-0 w-full h-full"
          ></iframe>
        </div>
        <div className="p-6 space-y-4">
          <div className="flex items-start gap-3">
            <MapPin className="h-5 w-5 text-primary flex-shrink-0 mt-1" />
            <div>
              <p className="text-gray-700">Carrer Sant Jacint, 32 - 1ª</p>
              <p className="text-gray-700">46980 Paterna (Valencia)</p>
            </div>
          </div>
          <a 
            href="https://maps.app.goo.gl/Ctca23JrVmHJoJLfA"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-primary text-white text-center px-4 py-1.5 rounded-full hover:bg-primary/90 transition-colors"
          >
            Cómo llegar
          </a>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6 space-y-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <Phone className="h-5 w-5 text-primary" />
            <a 
              href="tel:+34654261502"
              className="text-gray-700 hover:text-primary transition-colors"
            >
              Tel. 654 26 15 02
            </a>
          </div>
          <div className="flex items-start gap-3">
            <Clock className="h-5 w-5 text-primary flex-shrink-0 mt-1" />
            <div className="text-gray-700">
              <p>De Lunes a Viernes: 9.30h a 19.30h</p>
            </div>
          </div>
        </div>
        <a 
          href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
          className="block w-full bg-primary text-white text-center px-4 py-1.5 rounded-full hover:bg-primary/90 transition-colors"
        >
          CITA PREVIA
        </a>
      </div>
    </div>
  );
}